import { useServiceToken } from '@ltvco/refresh-lib/v1';
import { useMemo } from 'react';

import {
  API_CONFIG,
  createSearchFunction,
  fetchOramLegal,
} from 'routes/Dashboard/CourtCases/v2/shared/hooks';

import type {
  OpinionsResponse,
  PACERResponse,
} from 'routes/Dashboard/CourtCases/v2/types';

export function useChatLegalSearch() {
  const { data: tokenData, refetch: refetchToken } = useServiceToken('oram');

  const searchCaseLaw = useMemo(
    () =>
      createSearchFunction<OpinionsResponse>(
        'o',
        (url) =>
          fetchOramLegal<OpinionsResponse>(url, tokenData?.token, refetchToken),
        API_CONFIG.BASE_URL
      ),
    [tokenData?.token, refetchToken]
  );

  const searchPACER = useMemo(
    () =>
      createSearchFunction<PACERResponse>(
        'r',
        (url) =>
          fetchOramLegal<PACERResponse>(url, tokenData?.token, refetchToken),
        API_CONFIG.BASE_URL
      ),
    [tokenData?.token, refetchToken]
  );

  return { searchCaseLaw, searchPACER };
}
